module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-FurryBall-Web-1280.b7c8ca19.jpg";